<template>

  <div class="modal fade" id="guestDeleteModal" tabindex="-1" aria-labelledby="guestDeleteModalLabel" aria-hidden="true" ref="modalRef">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="guestDeleteModalLabel">Megerősítés szükséges</h5>
        </div>
        <div class="modal-body">
          <p>A családtag részvételének törlésével törlöd a hozzá kapcsolódó jelentkezéseket / nevezéseket is. Biztos, hogy törlöd a családtag részvételét?</p>
        </div>
        <div class="modal-footer">
          <button type="button" @click="agree" class="btn btn-danger" data-bs-dismiss="modal">Igen</button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Mégse</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { Modal } from 'bootstrap'
import UserAccount from '@/views/User/Account'

export default {
  name: 'GuestDeleteAgree',
  props: ['initData'],
  data(){
    return{
      modalInstance : null,

    }
  },
  methods:{
    agree(){
      this.closeModal()

      UserAccount.methods.guestDelete(this.$parent,this.initData.modals.guestAgree,true)
    },
    openModal(){
      this.modalInstance = new Modal(document.getElementById('guestDeleteModal'))
      this.modalInstance.show()
    },
    closeModal(){
      this.modalInstance = new Modal(document.getElementById('guestDeleteModal'))
      this.modalInstance.hide();
    }
  }
}
</script>
<style>

</style>